import {getAllProviderCategoriesByCompanyId} from '../../../../../../../../crud/management_api/providers';

export interface CategoriesOption{
  id: number;
  name: string;
}

export const getCategoriesOptions = async () => {
  try {
    const userContext = localStorage.getItem('user');
    const companyId = userContext != null ? JSON.parse(userContext).company_id : 0;
    const response = await getAllProviderCategoriesByCompanyId(companyId);
    if (response) {
      const data = response.data;
      if (data) {
        const categories: CategoriesOption[] = data.map((categories: any) => {
          return {
            id: categories.category_id,
            name: categories.name,
          };
        });
        return categories;
      }
    }
    return [];
  } catch (error: any) {
    // Si es 404, simplemente retorna [] y no lances el error
    if (error?.response?.status === 404) {
      return [];
    }
    // Para otros errores, también retorna [] para evitar uncaught
    return [];
  }
};